import React from "react";
import BrandContainer from "../../Components/Brand/BrandContainer";
import Pagination from "../../Components/Utilities/Pagination";
import BrandPageHook from "../../hook/brand/BrandPageHook";
import CategoryHeader from "../../Components/Category/CategoryHeader";
import { useSelector } from "react-redux";

const BrandPage = () => {
  const [brand, loading, pageCount] = BrandPageHook();
  const settingsData = useSelector((state) => state.settingsReducers.settings);

  return (
    <div style={{ minHeight: "670px" }}>
      {settingsData?.data && settingsData?.data?.showNavHeader === true ? (
        <CategoryHeader />
      ) : null}
      <BrandContainer data={brand?.filter(brand=>brand?.status === true)} loading={loading} />
      {/* <Pagination pageCount={pageCount} onPress={()=>{}} /> */}
    </div>
  );
};

export default BrandPage;
